import { render, staticRenderFns } from "./CategoryNavigationItem.vue?vue&type=template&id=09dd1568&scoped=true&"
import script from "./CategoryNavigationItem.vue?vue&type=script&lang=js&"
export * from "./CategoryNavigationItem.vue?vue&type=script&lang=js&"
import style0 from "./CategoryNavigationItem.vue?vue&type=style&index=0&id=09dd1568&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09dd1568",
  null
  
)

export default component.exports